import _ from 'lodash';
import React from 'react';
import { BsCameraFill } from 'react-icons/bs';
import { createUseStyles } from 'react-jss';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { Hint } from '../hint';

function ItemTitle({ item }) {
  const { menuLayout } = useStorage();
  const classes = useStyles({ layout: menuLayout, item });

  return (
    <div className={classes.container}>
      <span className={classes.name}>
        {item.image?.url != null && <BsCameraFill className={classes.icon} />}{' '}
        {item.name}
      </span>
      {item.hint && (
        <div className={classes.hint}>
          <Hint value={item.hint} showParenthesis />
        </div>
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // fontSize: layoutDefaults.fontSize,
    // border: '1px solid green',
  },
  name: {
    // display: 'inline-block',
    fontWeight: ({ item }) =>
      _.isEmpty(item?.description) ? 'normal' : 'bold',
    // textShadow: layout => `1px 1px 2px ${parseContainerBackgroundShade(layout, 12)}`,
    marginRight: ({ item }) =>
      item.hint && layoutDefaults.smallerHorizontalMargin,
    // border: '1px solid blue',
  },
  icon: {
    marginBottom: 4,
  },
  hint: {
    display: 'inline-block',
    opacity: layoutDefaults.opacity,
    fontSize: layoutDefaults.smallerFontSize,
    // border: '1px solid green',
  },
});

export { ItemTitle };
